import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <Helmet>
        <title>Yhteystiedot - Ota yhteyttä Sipelius Kotipalveluun Lahdessa | 044 246 5506</title>
        <meta name="description" content="Ota yhteyttä Sipelius Kotipalveluun Lahdessa. Riikka, puh. 044 246 5506, sipeliuskotipalvelu@gmail.com. Kotisiivous, senioriapu ja henkilökohtainen apu." />
        <meta name="keywords" content="yhteystiedot Sipelius Kotipalvelu, Riikka puhelin, kotipalvelu Lahti yhteystiedot, senioripalvelut Lahti, senioriapu Lahti, 044 246 5506, sipeliuskotipalvelu gmail" />
        <link rel="canonical" href="https://sipelius-kotipalvelu.fi/yhteystiedot" />
        <meta property="og:title" content="Yhteystiedot - Ota yhteyttä Sipelius Kotipalveluun Lahdessa" />
        <meta property="og:description" content="Ota yhteyttä Sipelius Kotipalveluun Lahdessa. Riikka, puh. 044 246 5506, sipeliuskotipalvelu@gmail.com. Kotisiivous, senioriapu ja henkilökohtainen apu." />
        <meta property="og:url" content="https://sipelius-kotipalvelu.fi/yhteystiedot" />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className="contact-hero">
        <div className="container">
          <h1>Yhteystiedot</h1>
          <p className="hero-subtitle">
            Ota yhteyttä niin keskustellaan tarpeistasi ja sopivasta palvelusta
          </p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Ota yhteyttä</h2>
              <p>
                Olen aina kiinnostunut kuulemaan uusista asiakkaista ja auttamaan 
                sinua löytämään sopivan ratkaisun tarpeisiisi. Ota rohkeasti yhteyttä!
              </p>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" fill="#bd8855"/>
                    </svg>
                  </div>
                  <div className="contact-details">
                    <h3>Puhelin</h3>
                    <a href="tel:0442465506">044 246 5506</a>
                    <div className="button-container">
                      <a href="tel:0442465506" className="cta-button secondary">
                        Soita nyt
                      </a>
                    </div>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" fill="#bd8855"/>
                      <path d="M22 6l-10 7L2 6" fill="#bd8855"/>
                    </svg>
                  </div>
                  <div className="contact-details">
                    <h3>Sähköposti</h3>
                    <a href="mailto:sipeliuskotipalvelu@gmail.com">sipeliuskotipalvelu@gmail.com</a>
                    <div className="button-container">
                      <a href="mailto:sipeliuskotipalvelu@gmail.com" className="cta-button secondary">
                        Lähetä viesti
                      </a>
                    </div>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" fill="#bd8855"/>
                      <circle cx="12" cy="10" r="3" fill="#bd8855"/>
                    </svg>
                  </div>
                  <div className="contact-details">
                    <h3>Toiminta-alue</h3>
                    <p>Lahti, Hollola, Heinola ja Orimattila</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" fill="#bd8855"/>
                      <polygon points="10,8 16,12 10,16" fill="white"/>
                    </svg>
                  </div>
                  <div className="contact-details">
                    <h3>Työajat</h3>
                    <p>Maanantai - Perjantai: 7:00 - 18:00<br/>
                    Viikonloppu: Sopimuksen mukaan</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 